import { DropdownItem } from '@/common/components';

export const languageOptions: DropdownItem[] = [{ id: 'english', label: 'English' }];
